import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  BehaviorSubject,
  Observable,
  shareReplay,
  switchMap,
  take,
} from 'rxjs';
import { UiWebComponentControllerService } from '../cc-api/services';
import { WebComponentDTO } from '../cc-api/models';
import { CustomToastService } from '../pages/custom-toast/custom-toast.service';

export interface NavAppConfig {
  name: string;
  remoteUrl: string;
  componentName: string;
  attributes?: { key: string; value: string }[];
}

export interface NavAppResponse {
  configurations: NavAppConfig[];
  // Add other response fields if needed
}

@Injectable({
  providedIn: 'root',
})
export class NavAppService {
  private sidebarConfigCache$: Observable<WebComponentDTO[]>;
  private triggerRefresh$ = new BehaviorSubject<boolean>(true); // BehaviorSubject emits true once when initialized

  constructor(private webComponentsService: UiWebComponentControllerService) {}

  // /**
  //  * Fetches navigation configurations from the backend
  //  * @returns Observable of NavAppConfig array
  //  */
  // getNavigationConfigs(): Observable<WebComponentDTO[]> {
  //   return this.webComponentsService.getAllComponentsUsingGET();
  // }

  /**
   * Returns the cached navigation config on subsequent calls.
   * The data is fetched once and shared across all subscribers using shareReplay.
   * To force a refresh, call `resetSidebarConfigs()`.
   */
  getNavigationConfigs(): Observable<WebComponentDTO[]> {
    if (!this.sidebarConfigCache$) {
      this.sidebarConfigCache$ = this.triggerRefresh$.pipe(
        take(1), // Only take the first trigger emission
        switchMap(() => this.webComponentsService.getAllComponentsUsingGET()),
        shareReplay(1), // Ensures a single API call is shared among multiple subscribers (e.g., sidebar-utils and nav-app)
      );
    }
    return this.sidebarConfigCache$;
  }

  /**
   * Force-refreshes the navigation config from API.
   */
  resetSidebarConfigs(): void {
    this.sidebarConfigCache$ = undefined as any; // clear the cache
    this.triggerRefresh$.next(true); // trigger a new fetch
  }
}
